// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
.enterCode_inputWrapper__Ftjwb {
  position: relative;
}
.enterCode_inputWrapper__Ftjwb::before {
  content: "";
  width: 14px;
  height: 2px;
  display: block;
  position: absolute;
  bottom: 20%;
  left: 50%;
  background: #000000;
  z-index: 100;
  transform: translate(-50%, 0);
}
.enterCode_inputWrapper__Ftjwb.enterCode_focused__hQUBg::before {
  display: none;
}

.enterCode_input__y\\+dXs {
  outline: none;
  padding: 7px 25px 0px 27px;
  width: 80px;
  height: 75px;
  border-radius: 30px;
  background: #FAFAFA;
  border: 5px solid #FAFAFA;
  font-size: 30px;
  color: #000;
  font-family: GteDisplayExtra;
}
.enterCode_input__y\\+dXs:focus {
  border: 5px solid #C7FF24;
}

.enterCode_wrapper__rwvLy {
  display: flex;
  align-items: center;
  grid-gap: 10px;
  margin-top: 35px;
  justify-content: space-between;
}

.enterCode_body__bmXM9 button {
  width: 100%;
  padding: 14px 0;
  border-radius: 30px;
  text-align: center;
  background: #C7FF24;
  color: #000;
  font-family: GteDisplayBold;
  font-weight: 500;
  font-size: 16px;
  margin-top: 100%;
}
.enterCode_body__bmXM9 button:disabled {
  background: #FAFAFA;
  color: #C2C2C2;
}`, "",{"version":3,"sources":["webpack://./src/components/enterCode/enterCode.module.scss"],"names":[],"mappings":"AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAKA;EACE,kBAAA;AAHF;AAIE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AAFJ;AAOI;EACE,aAAA;AALN;;AAUA;EACE,aAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;AAPF;AASE;EACE,yBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,8BAAA;AARF;;AAYE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AATJ;AAWI;EACE,mBAAA;EACA,cAAA;AATN","sourcesContent":["\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n\r\n\r\n.inputWrapper {\r\n  position: relative;\r\n  &::before {\r\n    content: \"\";\r\n    width: 14px;\r\n    height: 2px;\r\n    display: block;\r\n    position: absolute;\r\n    bottom: 20%;\r\n    left: 50%;\r\n    background: #000000;\r\n    z-index: 100;\r\n    transform: translate(-50%, 0);\r\n  }\r\n\r\n\r\n  &.focused {\r\n    &::before {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.input {\r\n  outline: none;\r\n  padding: 7px 25px 0px 27px;\r\n  width: 80px;\r\n  height: 75px;\r\n  border-radius: 30px;\r\n  background: #FAFAFA;\r\n  border: 5px solid #FAFAFA;\r\n  font-size: 30px;\r\n  color: #000;\r\n  font-family: GteDisplayExtra;\r\n\r\n  &:focus {\r\n    border: 5px solid #C7FF24;\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  grid-gap: 10px;\r\n  margin-top: 35px;\r\n  justify-content: space-between;\r\n}\r\n\r\n.body {\r\n  button {\r\n    width: 100%;\r\n    padding: 14px 0;\r\n    border-radius: 30px;\r\n    text-align: center;\r\n    background: #C7FF24;\r\n    color: #000;\r\n    font-family: GteDisplayBold;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    margin-top: 100%;\r\n    \r\n    &:disabled {\r\n      background: #FAFAFA;\r\n      color: #C2C2C2;\r\n    }\r\n    \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": `enterCode_inputWrapper__Ftjwb`,
	"focused": `enterCode_focused__hQUBg`,
	"input": `enterCode_input__y+dXs`,
	"wrapper": `enterCode_wrapper__rwvLy`,
	"body": `enterCode_body__bmXM9`
};
export default ___CSS_LOADER_EXPORT___;
